// src/components/pages/Pessoa/boot/getPessoaBoot.js

import { getPessoaBootBase } from './getPessoaBootBase';
import { getPessoaBootByTipo } from './getPessoaBootByTipo';

export function getPessoaBoot({ tipo, empresaId } = {}) {
    return {
        ...getPessoaBootBase({ empresaId }),
        ...getPessoaBootByTipo(tipo),
    };
}
